// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getClinicVideos } from "../../api";
import { ClinicVideoType } from "../../types";

export const useClinicVideos = (clinicId: string | undefined) => {
  const { getToken } = useTokenAccess();

  return useQuery<{ videos: Array<ClinicVideoType> }>({
    queryKey: ["clinic-videos", clinicId],
    queryFn: async () => {
      if (!clinicId) throw new Error();

      const token = await getToken();
      return getClinicVideos(token, clinicId);
    },
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
